// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-bar {
  display: flex;
  flex-grow: 1;
  margin-right: 1%;
  height: -moz-fit-content;
  height: fit-content;
}

.search-items {
  flex-direction: row;
  justify-content: start;
  height: -moz-fit-content;
  height: fit-content;
}

.search-actions {
  height: 35px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
